import React, { Component } from 'react';
import axios from '../lib/axios';
import StoriesSlider from './StoriesSlider';

export default class StoriesBar extends Component{
  constructor(props) {
    super(props);
    this.state = { stories: [], opened: false, index: 0 };
  }
  
  closeStories = () => {
    this.setState({ opened: false });
  }

  componentWillMount() {
		axios.get('/stories')
		.then(response => this.setState({stories: response.data.stories}))
	}

  render() {
    if (this.state.stories.length === 0)
      return null;
    return (
      <div>
        <section className="stories-bar custom-horizontal-scrollbar">
          <ul>
            {this.state.stories.map((story, key) => (
              <li className={`${story.seen ? "active" : ""}`} key={key}>
                <button onClick={() => this.setState({ index: key, opened: true})}>
                  <div>
                    <span>
                      <img src={story.thumb} alt="" />
                    </span>
                  </div>
                  <p>{story.name}</p>
                </button>
              </li>
            ))}
          </ul>
        </section>
        {
          this.state.opened && 
          <StoriesSlider startIndex={this.state.index} stories={this.state.stories} closeStories={this.closeStories} />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/StoriesBar.js